class HeaderSearch extends ToggleElementClass {
  constructor() {
    super();
  }

  construct() {
    super.construct();

    // elements
    this.header = this.closest("[data-header]");
    this.searchInput = this.querySelector("#search-input");

    // options
    const { toggleClass, target } = this.options;

    // key up escape
    document.addEventListener("keyup", (event) => {
      this.onKeyUp(event);
    });

    // Remove classes incase the header navigation drawer is open.
    this.addEventListener("click", () => {
      document.body.classList.remove("header-is-open");
      document.body.classList.remove("menu-drawer-is-open");

      // Focus on input element if provided
      if (this.options.focusTarget) {
        document.querySelector(this.options.focusTarget)?.focus();
      }
    });

    // this.words = this.searchInput?.dataset.placeholder.split(" ");
    this.words = this.searchInput?.dataset.placeholder
      .split("; ")
      .filter(Boolean);
    this.interval = 0;
    this.timer;
  }

  connectedCallback() {
    if (this.searchInput?.dataset.enableAnimation === "true") {
      this.typingEffect();
      this.isTypingEffectInitialized = true;
    } else {
      if (this.searchInput){
        this.searchInput.placeholder = this.searchInput?.dataset.placeholder;
      }
    }
  }

  onKeyUp(event) {
    if (!document.body.classList.contains("header-search-is-open")) {
      return;
    }
    if (event?.code.toUpperCase() !== "ESCAPE") {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.header) {
      document.body.classList.add("header-search-is-open");
    }
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    if (this.header) {
      document.body.classList.remove("header-search-is-open");
    }
    removeTrapFocus();
  }

  typingEffect() {
    // Get the current phrase to type
    let phrase = this.words[this.interval];
    let part = 0; // Tracks the current part of the phrase being typed

    const loopTyping = () => {
      if (part < phrase.length) {
        // Add one character at a time to the placeholder
        this.searchInput.placeholder += phrase.charAt(part);
        part++;
      } else {
        // Once the entire phrase is typed out, start the deleting effect
        this.deletingEffect();
        return;
      }
      this.timer = setTimeout(loopTyping, 400);
    };
    loopTyping();
  }

  deletingEffect() {
    // Directly use the placeholder content for deletion to handle multiple words
    const loopDeleting = () => {
      if (this.searchInput.placeholder.length > 0) {
        // Remove one character at a time from the end of the placeholder
        this.searchInput.placeholder = this.searchInput.placeholder.substring(
          0,
          this.searchInput.placeholder.length - 1
        );
      } else {
        // Move to the next phrase or loop back to the start
        if (this.words.length > this.interval + 1) {
          this.interval++;
        } else {
          this.interval = 0;
        }
        // Once deletion is complete, start typing the next phrase
        this.typingEffect();
        return;
      }
      this.timer = setTimeout(loopDeleting, 200);
    };
    loopDeleting();
  }
}

if (!customElements.get("header-search")) {
  customElements.define("header-search", HeaderSearch);
}
